import React, { useContext, useState } from 'react';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';

const EnquirySearch = () => {
  const { searchFilter, setSearchFilter } = useContext(ViewContext);
  const [clearInput, toggleClearInput] = useState(false);

  const handleSubmit = e => {
    e?.preventDefault();
    e?.stopPropagation();

    inboxService.threads();

    if (!clearInput) toggleClearInput(true);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleSubmit();
    }

    if (clearInput) toggleClearInput(false);
  }

  return (
    <div className='enquiry-search'>
      <form
        onSubmit={handleSubmit}>
        <input
          name='search'
          placeholder='Search Enquiries'
          onKeyDown={handleKeyDown}
          value={searchFilter}
          onChange={(e) => setSearchFilter(e.target.value)}
        />
      </form>
      {clearInput ? (
        <svg
          className='enquiry-search__icon'
          xmlns='http://www.w3.org/2000/svg'
          width='15'
          height='15'
          fill='none'
          onClick={e => {
            e.stopPropagation();
            setSearchFilter('');
            toggleClearInput(false);
            setTimeout(() => handleSubmit(), 200)
          }}>
          <g clipPath='url(#A)'>
            <path d='M8.328 7.501l6.5-6.5c.229-.229.229-.6 0-.829s-.6-.229-.829 0l-6.5 6.5L1 .172C.771-.056.4-.056.171.172s-.229.6 0 .829l6.5 6.5-6.5 6.5c-.229.229-.229.6 0 .829.114.114.264.172.414.172s.3-.057.414-.172l6.5-6.5 6.5 6.5c.114.114.264.172.414.172s.3-.057.414-.172c.229-.229.229-.6 0-.829l-6.5-6.5z' />
          </g>
          <defs>
            <clipPath id='A'>
              <path fill='#fff' d='M0 0h15v15H0z' />
            </clipPath>
            x
          </defs>
        </svg>
      ) : (
        <svg
          className='enquiry-search__icon'
          xmlns='http://www.w3.org/2000/svg'
          width='19'
          height='19'
          fill='none'
          onClick={handleSubmit}>
          <path d='M18.768 17.649l-5.403-5.403c1.047-1.293 1.677-2.935 1.677-4.725A7.53 7.53 0 0 0 7.521 0 7.53 7.53 0 0 0 0 7.521a7.53 7.53 0 0 0 7.521 7.521c1.789 0 3.432-.63 4.725-1.677l5.403 5.403a.79.79 0 0 0 1.119 0 .79.79 0 0 0 0-1.119zm-11.247-4.19c-3.274 0-5.937-2.663-5.937-5.937s2.663-5.937 5.937-5.937 5.937 2.663 5.937 5.937-2.663 5.937-5.937 5.937z' />
        </svg>
      )}
    </div>
  );
};

export default EnquirySearch;
